import { FileDown } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SectionLabel } from "@/components/SectionLabel";
import { BROCHURE_URL } from "@/data/eventData";

const Brochure = () => (
    <section id="brochure" data-testid="brochure-section" className="scroll-mt-24 py-24 md:py-32">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
            <Reveal>
                <div className="relative overflow-hidden border border-cream/10 bg-coal p-8 md:p-16">
                    <div
                        aria-hidden="true"
                        className="absolute inset-0 bg-[radial-gradient(ellipse_70%_80%_at_90%_110%,rgba(201,31,38,0.16),transparent_60%)]"
                    />
                    <div className="relative flex flex-col gap-10 md:flex-row md:items-end md:justify-between">
                        <div>
                            <SectionLabel index="07" text="The Brochure" />
                            <h2 className="mt-8 font-serif text-4xl font-light leading-[1.05] tracking-tight text-cream sm:text-5xl">
                                One Document.
                                <br />
                                Every <em className="italic text-scarlet">Detail.</em>
                            </h2>
                            <p className="mt-6 max-w-md text-base font-light leading-relaxed text-ash">
                                Committees, agendas, prizes and the spirit of I-ACE
                                Chapter 4 — collected in the official brochure.
                            </p>
                        </div>
                        <a
                            href={BROCHURE_URL}
                            download="I-ACE-4.0-Brochure.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="brochure-download-btn"
                            className="group inline-flex w-full items-center justify-center gap-3 bg-crimson px-9 py-4 font-sans text-xs font-semibold uppercase tracking-[0.25em] text-cream transition-colors duration-300 hover:bg-scarlet md:w-auto"
                        >
                            Download Brochure
                            <FileDown className="h-4 w-4 transition-transform duration-300 group-hover:translate-y-0.5" />
                        </a>
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);

export default Brochure;
